module.exports = __webpack_public_path__ + "img/def.9fbfe3d3.jpg";